var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42001 0.762429L8.42076 0.763958L10.369 4.77262L10.4845 5.01016L10.7458 5.0487L15.0986 5.69088C15.0988 5.69091 15.099 5.69093 15.0992 5.69096C15.2748 5.7175 15.4205 5.84039 15.4768 6.01079C15.5319 6.17763 15.4871 6.36418 15.3607 6.48911L15.3605 6.4893L12.2032 9.6132L12.0185 9.79598L12.0619 10.0522L12.8101 14.4655C12.8101 14.4657 12.8102 14.4658 12.8102 14.466C12.8391 14.6405 12.7668 14.8194 12.6184 14.9273C12.4764 15.0306 12.2848 15.0449 12.1225 14.9596C12.1222 14.9595 12.122 14.9593 12.1217 14.9592L8.23634 12.8848L8.00085 12.759L7.76536 12.8848L3.88001 14.9592C3.87973 14.9593 3.87946 14.9595 3.87918 14.9596C3.7196 15.0434 3.52629 15.0298 3.38065 14.9254C3.23655 14.822 3.16227 14.6425 3.19151 14.466C3.19154 14.4658 3.19156 14.4657 3.19159 14.4655L3.93679 10.0519L3.98002 9.79583L3.79544 9.6132L0.638201 6.4893L0.638008 6.48911C0.51395 6.36649 0.467724 6.17927 0.523131 6.00706C0.576117 5.84237 0.72125 5.71785 0.899642 5.69094C0.899773 5.69092 0.899904 5.6909 0.900035 5.69088L5.24994 5.0487L5.51118 5.01013L5.62661 4.77262L7.57402 0.765732C7.57415 0.765477 7.57427 0.765222 7.5744 0.764966C7.65498 0.601537 7.81808 0.5 7.99782 0.5C8.1803 0.5 8.34356 0.603752 8.42001 0.762429Z",
    fill: "url(#paint0_linear_366_7404)",
    stroke: "url(#paint1_linear_366_7404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_7404",
    x1: 1.74062e-7,
    y1: 1.10822,
    x2: 16.3232,
    y2: 1.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_366_7404",
    x1: 1.74062e-7,
    y1: 1.10822,
    x2: 16.3232,
    y2: 1.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/fav-icon.0c7b1e9effd2c0b2dc74d3a2b10f227e.svg";
export { ForwardRef as ReactComponent };